import React from "react";
import { Box, Typography } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import {
  BgBox,
  InlineFlexBoxs,
  SmallBgBox,
  ListItems,
  Titles,
  WithoutSeparator
} from "my-tax/styles/my-tax-credit-information.style";
import { OcFooter } from "oc/components";
import { ocLightTheme } from "oc/themes/oc-light-theme";

export const MyTaxCombinedTaxCreditInformationPage = () => {
  return (
    //Ha eltávolítjuk a ThemeProvider-ert, akkor nem jeleníti meg a stílusokat. Feltételezhetően azért, mert új tab-on nyílik meg.
    //If we remove the ThemeProvider, it will not display the styles. Probably because it opens in a new tab.
    <ThemeProvider theme={ocLightTheme}>
      <Box>
        <Box padding="16px" style={{ backgroundColor: "#F1F3F4" }}>
          <Box>
            <Typography
              variant="h4"
              style={{
                fontSize: "34px",
                fontWeight: "400",
                color: "#5E6366",
                display: "flex",
                justifyContent: "center",
              }}
            >
              Tájékoztató
            </Typography>
            <Box height="32px" />
            <Typography
              variant="h5"
              style={{
                fontSize: "24px",
                fontWeight: "400",
                color: "#212121",
                display: "flex",
                justifyContent: "center",
              }}
            >
              a családi kedvezmény, a családi járulékkedvezmény, és a két, a három, illetve a
              négy vagy több gyermeket nevelő anyák kedvezménye érvényesítéséről szóló
              adóelőleg-nyilatkozathoz
            </Typography>
            <Box height="32px" />
            <BgBox>
              <Typography variant="h6">
                <b>Ki adhatja be ezt az adóelőleg-nyilatkozatot?</b>
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                <b>Ezt az adóelőleg -nyilatkozatot csak az a nő töltheti ki, aki</b>
              </Typography>
              <Box height="10px" />
              <Typography variant="body1" component={ListItems}>
                <li><b>családi kedvezményre és</b></li>
                <li>a két gyermeket nevelő anyák kedvezményére vagy</li>
                <li>a három gyermeket nevelő anyák kedvezményére vagy</li>
                <li>a négy vagy több gyermeket nevelő anyák kedvezményére</li>
              </Typography>
              <Typography variant="body1">
                <b>is jogosult!</b>
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                <b>2026-ban beadhatja ezt az adóelőleg nyilatkozatot</b>
              </Typography>
              <Box height="10px" />
              <Typography variant="body1" component={ListItems}>
                <li>az a 35 éves anya, aki a két vérszerinti kisiskolás gyermekét neveli (két
                  gyermekes anya),</li>
                <li>az a 46 éves anya, aki két saját gyermekét és egy örökbefogadott kiskorú
                  gyermeket nevel (három gyermekes anya),</li>
                <li>az az 57 éves édesanya, akinek három gyermeke már felnőtt, elköltöztek, de a
                  negyedik 26 éves vele él, rokkantsági járadékban részesül és a családi
                  kedvezményt az édesanya érvényesíti utána (négy gyermekes anya).</li>
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                <b>Nem ezt az adóelőleg nyilatkozatot kell beadnia az anyának, ha</b>
              </Typography>
              <Box height="10px" />
              <Typography variant="body1" component={ListItems}>
                <li>42 évesen neveli két kiskorú gyermekét (családi kedvezményre jogosult, de a két
                  gyermeket nevelő anyák kedvezményére nem),</li>
                <li>48 évesen három gyermeket nevel, akik közül kettő a vérszerinti gyermeke, egy
                  pedig az élettársa előző kapcsolatából származik,</li>
                <li>50 évesen négy gyermeket nevel, kettő a sajátja, kettőnek pedig a nevelőszülője,</li>
                <li>három felnőtt, vérszerinti gyermeke van (családi kedvezményre már nem
                  jogosult).</li>
              </Typography>
            </BgBox>
            <Box height="16px" />
            <InlineFlexBoxs>
              <BgBox>
                <Box height="25px" />
                <Typography variant="h5" component={Titles}>
                  <b>Tudnivalók a nyilatkozathoz</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>A családi kedvezményre (ideértve a családi járulékkedvezményt) és a két
                    gyermeket nevelő anyák kedvezményére, vagy a három gyermeket nevelő anyák
                    kedvezményére, vagy a négy vagy több gyermeket nevelő anyák kedvezményére
                    jogosult anya ezen az adóelőleg-nyilatkozaton kérheti, hogy a munkáltató, kifizető
                    az adóelőleg megállapításakor mindkét kedvezményt vegye figyelembe.</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  A több gyermeket nevelő anyák kedvezménye alatt együttesen értjük a két gyermeket
                  nevelő anyák kedvezményét, a három gyermeket nevelő anyák kedvezményét és a négy
                  vagy több gyermeket nevelő anyák kedvezményét
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>Ha Ön csak a családi kedvezményre jogosult, akkor a „Családi kedvezmény
                    nyilatkozat” elnevezésű nyomtatványt töltse ki és adja be.
                    Ha Ön jogosult a több gyermekes anyák kedvezményére, de családi kedvezményre
                    nem, akkor a „Több gyermeket nevelő anyák kedvezménye” elnevezésű adóelőleg
                    nyilatkozatot adja be.</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  A családi kedvezményt a jogosult házastársak, élettársak – az összeg vagy a
                  kedvezményezett eltartottak számának felosztásával – <b>közösen is igénybe vehetik.</b> Ha
                  a családi kedvezményre ugyanazon kedvezményezett eltartott után többen jogosultak,
                  illetve, ha a családi kedvezményt közösen veszik igénybe, akkor a nyilatkozatot közösen
                  kell megtenni.
                </Typography>
                <Typography variant="body1">
                  Ez azt jelenti, hogy a több gyermekes anyák kedvezményére jogosult nőnek, ha a családi
                  kedvezményt az arra jogosult házastársával, élettársával közösen veszi igénybe, akkor
                  ezen az adóelőleg-nyilatkozaton a közös igénybevételről is kell nyilatkoznia.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  2026. január 1-től a magánszemélyek által igénybe vehető adóalap-kedvezmények
                  érvényesítési sorrendje a következő:
                </Typography>
                <Box height="25px" />
                <Box marginLeft="20px">
                  <Typography variant="body1">
                    a) a 30 év alatti anyák kedvezménye,
                  </Typography>
                  <Box height="10px" />
                  <Typography variant="body1">
                    b) <b>a négy vagy több gyermeket nevelő anyák kedvezménye, a három gyermeket
                      nevelő anyák kedvezménye vagy a két gyermeket nevelő anyák kedvezménye,</b>
                  </Typography>
                  <Box height="10px" />
                  <Typography variant="body1">
                    c) a csecsemőgondozási díj, a gyermekgondozási díj és az örökbefogadói díj kedvezménye,
                  </Typography>
                  <Box height="10px" />
                  <Typography variant="body1">
                    d) a 25 év alatti fiatalok kedvezménye,
                  </Typography>
                  <Box height="10px" />
                  <Typography variant="body1">
                    e) a személyi kedvezmény,
                  </Typography>
                  <Box height="10px" />
                  <Typography variant="body1">
                    f) az első házasok kedvezménye,
                  </Typography>
                  <Box height="10px" />
                  <Typography variant="body1">
                    g) a <b>családi kedvezmény és a családi járulékkedvezmény.</b>
                  </Typography>
                </Box>
                <Box height="25px" />
                <Typography variant="h6">
                  <b>Kinek kell átadni ezt a nyilatkozatot?</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Ahhoz, hogy a munkáltatója, kifizetője az Ön törvényben meghatározott jövedelmeire a
                  családi kedvezményt és a több gyermeket nevelő anyák kedvezményét figyelembe véve
                  állapítsa meg az adóelőleget, ezt a nyilatkozatot két példányban kell átadnia részére.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  A nyilatkozat egyik példányát a munkáltatónak (kifizetőnek), másik példányát pedig
                  Önnek kell a bevallás benyújtásának évét követő 5. év végéig megőriznie.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Az adóelőleg-nyilatkozatot a kedvezmények alapját képező jövedelmet juttató
                  <b> munkáltatójának, vagy rendszeres jövedelmet juttató kifizetőjének</b> adhatja át. A
                  <b> nem rendszeres bevételt juttató kifizetőtől a családi kedvezmény érvényesítése nem
                    kérhető,</b> ezért nem ezt a nyilatkozatot, hanem a két, a három, illetve a négy vagy több
                  gyermeket nevelő anyák kedvezményének érvényesítéséről szóló adóelőleg-
                  nyilatkozatot kell leadnia.
                </Typography>
                <Typography variant="body1">
                  A munkáltató, kifizető a nyilatkozatot az adóéven belül, az átadást követő kifizetéseknél
                  veszi figyelembe.
                </Typography>
                <Typography variant="body1">
                  A családi kedvezményre vonatkozó nyilatkozatot a munkáltató, kifizető csak az adóéven
                  belül veszi figyelembe.
                </Typography>
                <Typography variant="body1">
                  <b>A többgyermekes anyák kedvezményére vonatkozó adóelőleg nyilatkozatot a
                    munkáltató, kifizető folytatólagosan veszi figyelembe, mindaddig, amíg Ön azt
                    módosítja, vagy visszavonja. Ez azt jelenti, hogy a több gyerekes anyának a
                    következő évben, években nem kell új nyilatkozatot adnia, ha továbbra is
                    ugyanarra a kedvezményre jogosult, amiről nyilatkozott.</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Mielőtt a nyilatkozatot leadná, a nyilatkozat 7. pontjában az Ön kedvezményre jogosult
                  házastársának vagy élettársának adatait is meg kell adnia. A családi kedvezményt a
                  bejegyzett élettársak is igénybe vehetik, ezért a házastárs kifejezés alatt a továbbiakban
                  a bejegyzett élettársat is érteni kell.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <i>Ha Ön a családi kedvezményt vagy a több gyermeket nevelő anyák kedvezményét
                    jogalap nélkül kéri, és emiatt az adóbevallásában 10 ezer forintot meghaladó befizetési
                    kötelezettsége, vagyis adóhátraléka keletkezik, akkor ennek 12 százalékát különbözeti
                    bírságként kell megfizetnie az adóhátralékkal együtt.</i>
                </Typography>
                <Box height="25px" />
                <Typography variant="h6">
                  <b>I. Kinek jár a családi kedvezmény?</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1" component={ListItems}>
                  <li><b>Annak a magánszemélynek, aki jogosult a családi pótlékra, ilyen például</b></li>
                </Typography>
                <Box marginLeft="24px">
                  <Typography variant="body1" component={ListItems}>
                    <li>a házastársként, élettársként együtt élő vér szerinti szülő,</li>
                    <li>a szülővel együtt élő élettárs, ha az érintett gyermekkel közös lakó- vagy
                      tartózkodási hellyel rendelkezik, és</li>
                  </Typography>
                </Box>
                <Box marginLeft="48px">
                  <Typography variant="body1" component={ListItems}>
                    <li>a szülővel élettársként legalább egy éve szerepel az Élettársi
                      Nyilatkozatok Nyilvántartásában (a jogosultság jogcímeként neki
                      is az „a” jogcímkódot kell szerepeltetnie), vagy</li>
                    <li>élettársi kapcsolatát a szülővel a családi pótlék kérelmezése előtt
                      legalább egy évvel kiállított közokirattal igazolja (a jogosultság
                      jogcímeként neki is az „a” jogcímkódot kell szerepeltetnie) (1.)</li>
                  </Typography>
                </Box>
                <Box height="25px" />
                <Typography variant="body1" component={ListItems}>
                  <li>A gyermeket azonos időtartamban felváltva gondozó, közös szülői felügyeletet
                    gyakorló külön élő szülők a családi pótlékra 50-50 százalékos arányban
                    jogosultak a Cst. alapján.</li>
                </Typography>
                <Box marginLeft="24px">
                  <Typography variant="body1" component={ListItems}>
                    <li>A felváltva gondozott gyermek után a szülők a családi kedvezményre is
                      50-50 százalékos arányban jogosultak.</li>
                    <li>A kedvezményt egymás között nem érvényesíthetik közösen, viszont a
                      jelenlegi házastársukkal a rájuk vonatkozó kedvezményt közösen is
                      igénybe vehetik.</li>
                    <li>A közös háztartásban élő, családi kedvezményre nem jogosult élettárssal
                      a kedvezményt nem lehet év közben közösen érvényesíteni, viszont az év
                      végi adóbevallásban a kedvezmény az élettárssal is megosztható.</li>
                  </Typography>
                </Box>
                <Box height="25px" />
                <Typography variant="body1" component={ListItems}>
                  <li><b>A családi pótlékra jogosulttal közös háztartásban élő, családi pótlékra nem
                    jogosult házastárs.</b></li>
                </Typography>
                <Box marginLeft="24px">
                  <Typography variant="body1" component={ListItems}>
                    <li>Év közben is érvényesítheti a családi kedvezményt az a magánszemély,
                      aki nem jogosult ugyan családi pótlékra, de az arra jogosult házastársával
                      közös háztartásban él. Például, ha a házastársak közül az egyik
                      nevelőszülő, a vonatkozó szabályok alapján csak ő jogosult a nevelt
                      gyermek után családi pótlékra, viszont házastársa is jogosult a házastársa
                      által nevelt gyermek után járó családi kedvezmény érvényesítésére, így
                      adóelőleg-nyilatkozatot tehet.</li>
                    <li>A közös háztartásban élő, családi kedvezményre nem jogosult élettárssal
                      a kedvezményt nem lehet év közben közösen érvényesíteni, viszont az év
                      végi adóbevallásban a kedvezmény az élettárssal megosztható.</li>
                  </Typography>
                </Box>
                <Box height="25px" />
                <Typography variant="body1" component={ListItems}>
                  <li><b>A várandós nő és a vele közös háztartásban élő házastársa.</b></li>
                </Typography>
                <Box marginLeft="24px">
                  <Typography variant="body1" component={ListItems}>
                    <li>A várandós nővel közös háztartásban élő élettárs a várandósság ideje alatt
                      nem jogosult a kedvezményre, így azt év közben az élettársak nem
                      érvényesíthetik közösen, viszont a várandós nőnek járó kedvezményt a
                      várandós nő a bevallásában megoszthatja élettársával.</li>
                  </Typography>
                </Box>
                <Box height="25px" />
                <Typography variant="body1" component={ListItems}>
                  <li><b>A családi pótlékra saját jogán jogosult gyermek, továbbá a rokkantsági
                    járadékban részesülő magánszemély.</b></li>
                </Typography>
                <Box marginLeft="24px">
                  <Typography variant="body1" component={ListItems}>
                    <li>Esetükben saját maga vagy a vele közös háztartásban élő hozzátartozói
                      közül közös döntéssel kiválasztott magánszemély érvényesíthet családi
                      kedvezményt. (Ettől a döntéstől év végén a bevallás benyújtásakor el lehet
                      térni.)</li>
                    <li>Hozzátartozónak kell tekinteni a gyermek szüleinek hozzátartozóit is, így
                      például az elhunyt szülő testvére is érvényesítheti a kedvezményt a vele
                      közös háztartásban élő árván maradt gyermek után.</li>
                  </Typography>
                </Box>
                <Box height="25px" />
                <Typography variant="body1" component={ListItems}>
                  <li>Az a magánszemély is érvényesítheti a családi kedvezményt, aki <b>valamely EGT-
                    állam vagy Magyarországgal határos, nem EGT-állam (Ukrajna, Szerbia)
                    jogszabálya alapján családi pótlékra, rokkantsági járadékra vagy más
                    hasonló ellátásra jogosult,</b> ha az egyéb feltételek teljesülnek.</li>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>Ha a családi kedvezményre több magánszemély jogosult, mindenképpen közösen
                    kell nyilatkozatot tenniük, akkor is, ha a kedvezményt teljes egészében a jogosultak
                    egyike érvényesíti.</b> Nem kell közös nyilatkozatot tenni a felváltva gondozott gyermek
                  vér szerinti szüleinek, mert ők a kedvezmény 50-50 százalékát a másik szülőtől
                  függetlenül érvényesíthetik. Ha az őket megillető kedvezményt jelenlegi házastársukkal
                  közösen érvényesítik, akkor jelenlegi házastársukkal közös nyilatkozatot kell tenniük.
                </Typography>
                <Box height="25px" />
                <Typography variant="h6">
                  <b>II. Kinek jár a több gyerekes anyák kedvezménye?</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>Több gyermeket nevelő anya az a nő,</b> aki <b>vér szerinti vagy örökbefogadó szülőként </b>
                  az általa nevelt két, három, illetve négy vagy több gyermek után:
                </Typography>
                <Box height="10px" />
                <Box marginLeft="20px">
                  <Typography variant="body1">
                    a) családi pótlékra jogosult, vagy
                  </Typography>
                  <Box height="10px" />
                  <Typography variant="body1">
                    b) családi pótlékra már nem jogosult, de legalább 12 éven keresztül jogosult volt,
                  </Typography>
                  <Box height="10px" />
                  <Typography variant="body1">
                    c) a családi pótlékra való jogosultsága a gyermek elhunyta miatt szűnt meg.
                  </Typography>
                </Box>
                <Box height="25px" />
                <Typography variant="body1">
                  Az a) pont szerinti gyermeknek kell tekinteni azt a gyermeket is, aki fogyatékkal élőként
                  szociális intézményben látnak el, utána az anya családi pótlékra nem jogosult, de a
                  gyermeket az anyát megillető családi pótlék összegének meghatározásakor figyelembe
                  veszik.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  A b) pont szerinti gyermeknek kell tekinteni azt a gyermeket is, aki után az anya vagy a
                  szociális intézmény vezetője családi pótlékra való jogosultsága már nem áll fenn, de
                  legalább 12 éven keresztül e két személy valamelyike, vagy mindkettőjük esetében
                  összesen fennállt, feltéve, hogy a szociális intézmény vezetőjénél fennálló jogosultság
                  időszaka alatt az előző mondatban foglaltak teljesültek.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Például <b>négy vagy több gyermeket nevelő anyának számít</b> az a nő, aki:
                </Typography>
                <Box height="25px" />
                <Typography variant="body1" component={ListItems}>
                  <li>saját háztartásában neveli a 3, 6, 9 és 12 éves gyermekeit;</li>
                  <li>öt gyermeket szült, a szülők elváltak, amikor a két legidősebb gyermek 16 és 14
                    éves volt, a három fiatalabb gyermek az anyánál maradt, a két idősebb az apához került;</li>
                  <li>három gyermeket szült és nevelt: a legidősebb dolgozik, elköltözött otthonról, a
                    középső egyetemista, a harmadik középiskolába jár, és korábban örökbefogadott
                    egy 3 éves kislányt, aki 22 évesen költözött el a szülői házból.</li>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>Nem tekinthető négy vagy több gyermeket nevelő anyának</b> az a nő, aki például:
                </Typography>
                <Box height="25px" />
                <Typography variant="body1" component={ListItems}>
                  <li>négy gyermeket szült, de váláskor az apához került 10 éves kislánya;</li>
                  <li>második férjével közösen nevel négy kiskorú gyermeket, akik közül kettő a
                    sajátja, kettő a férjéé (kivéve, ha a férje gyermekeit örökbe fogadta).</li>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>Három gyermeket nevelő anya az a nő,</b> az a nő, aki például:
                </Typography>
                <Box height="25px" />
                <Typography variant="body1" component={ListItems}>
                  <li>egy egyetemista és két középiskolás gyermekét neveli;</li>
                  <li>három gyermeket szült, ebből kettőt felnevelt (már felnőttek), egyikük pedig
                    kisgyermekként elhunyt;</li>
                  <li>két gyermeket szült, akiket együtt nevel a férje gyermekével, akit korábban
                    örökbe fogadott.</li>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>Nem tekinthető három gyermeket nevelő anyának</b> az a nő, aki például:
                </Typography>
                <Box height="25px" />
                <Typography variant="body1" component={ListItems}>
                  <li>három gyermeket szült és nevel, de a legnagyobb, már felnőtt gyermeke
                    külföldön született, és emiatt utána csak 10 évig volt jogosult Magyarországon
                    családi pótlékra;</li>
                  <li>a két saját gyermeke mellett nevelőszülőként egy kislányt gondoz.</li>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>2026 január 1-től a két gyermeket nevelő anyák kedvezményét az az anya
                    érvényesítheti, aki 2025 december 31-e után tölti be a 40. életévét.</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>A két gyermeket nevelő anyák kedvezményét érvényesítheti</b> az a nő, aki például:
                </Typography>
                <Box height="25px" />
                <Typography variant="body1" component={ListItems}>
                  <li>36 éves és az óvodás és a kisiskolás gyermekét neveli, akik után családi pótlékot kap</li>
                  <li>2026. január 1-jén tölti be a 40. életévét és ikergyermekei már felnőttek,</li>
                  <li>32 éves és két örökbefogadott gyermeket nevel, akik után családi pótlékot kap.</li>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Nem érvényesítheti a két gyermeket nevelő anyák kedvezményét az az anya, aki
                </Typography>
                <Box height="25px" />
                <Typography variant="body1" component={ListItems}>
                  <li>férjével közösen neveli közös gyermeküket és a férfi előző kapcsolatából
                    származó gyermekét (kivéve, ha férje gyermekét örökbe fogadta),</li>
                  <li>saját gyermeke mellett nevelőszülőként egy kislányt nevel,</li>
                  <li>57 éves és két felnőtt gyermeke van.</li>
                </Typography>
                <Box height="25px" />
                <Typography variant="h6">
                  <b>Milyen jövedelmekre érvényesíthető a kedvezmény?</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>Családi kedvezmény</b>
                </Typography>
                <Typography variant="body1">
                  A családi kedvezmény igénybe vehető például a munkabérre, adóköteles
                  társadalombiztosítási ellátásra, más havi, heti munkadíjra, tiszteletdíjra, személyes
                  közreműködés ellenértékére, bérbeadásból származó jövedelemre, egyéb összevonás alá
                  eső jövedelemre.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>Több gyermeket nevelő anyák kedvezménye</b>
                </Typography>
                <Typography variant="body1">
                  A <b>több gyermekes anyák kedvezménye a törvényi előírások szerint az alábbi, a
                    jogosultsági hónapban megszerzett jövedelmekre vehető igénybe:</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1" component={ListItems}>
                  <li>a bérnek minősülő és más nem önálló tevékenységből származó jövedelemre,
                    ilyenek különösen:</li>
                </Typography>
                <Box marginLeft="24px">
                  <Typography variant="body1" component={ListItems}>
                    <li>a munkaviszonyból, közfoglalkoztatási jogviszonyból származó jövedelem,</li>
                    <li>az adóköteles társadalombiztosítási ellátás (például: táppénz,
                      csecsemőgondozási díj, gyermekgondozási díj),</li>
                    <li>a szociális igazgatásról és szociális ellátásokról szóló törvény alapján
                      folyósított adóköteles ellátások,</li>
                    <li>a foglalkoztatás elősegítéséről és a munkanélküliek ellátásáról szóló törvény
                      alapján folyósított álláskeresési járadék, nyugdíj előtti álláskeresési segély,
                      álláskeresési segély, kereset-kiegészítés és keresetpótló juttatás, álláskeresést
                      ösztönző juttatás;</li>
                    <li>a Magyar Honvédségnél tartalékos katonai szolgálatot teljesítő
                      magánszemély e jogviszonyból származó jövedelme,</li>
                    <li>ez előzőekben meghatározott jövedelmet pótló kártérítés (keresetpótló
                      járadék),</li>
                    <li>a nevelőszülői foglalkoztatási jogviszonyban végzett tevékenység díjazása,</li>
                    <li>a munkaviszony megszűnése miatt kifizetett végkielégítés, de a végkielégítés
                      törvényben meghatározott mértéket meghaladó része nem képezi a
                      kedvezmény alapját,</li>
                    <li>a társas vállalkozás magánszemély tagjának személyes közreműködése
                      ellenértékeként kifizetett jövedelem,</li>
                    <li>a gazdasági társaság vezető tisztségviselőjének tevékenységére tekintettel
                      adott juttatás,</li>
                    <li>a jogszabály alapján választott vagy kijelölt tisztségviselő tevékenysége
                      (például igazgatótanácsi tag, felügyelőbizottsági tag) ellenértékeként kapott
                      juttatás,</li>
                    <li>nemzetközi szerződés hatálya alatt a nem önálló munkából, ennek hiányában
                      az adott állam joga szerinti munkaviszonyból származó jövedelem,</li>
                    <li>az országgyűlési képviselők, nemzetiségi szószólók, polgármesterek e
                      tevékenységből származó jövedelme,</li>
                    <li>az állami projektértékelői jogviszonyból származó jövedelem.</li>
                  </Typography>
                </Box>
                <Box height="25px" />
                <Typography variant="body1" component={ListItems}>
                  <li>Az önálló tevékenységből származó jövedelmek közül:</li>
                </Typography>
                <Box marginLeft="24px">
                  <Typography variant="body1" component={ListItems}>
                    <li>a vállalkozói jövedelem szerinti adózást alkalmazó egyéni vállalkozó
                      vállalkozói kivétjére, átalányadózás esetén az átalányban megállapított
                      jövedelmére,</li>
                    <li>a mezőgazdasági őstermelő e tevékenységéből származó jövedelmére,</li>
                    <li>az európai parlamenti képviselő e tevékenységéből származó jövedelmére,</li>
                    <li>a helyi önkormányzati képviselő e tevékenységéből származó jövedelmére,</li>
                    <li>a választott könyvvizsgáló e tevékenységéből származó jövedelmére,</li>
                    <li>a magánszemély által nem egyéni vállalkozóként kötött, díjazás ellenében
                      történő munkavégzésre irányuló, más szerződés alapján folytatott
                      tevékenységéből, például megbízásból származó jövedelmére.</li>
                  </Typography>
                </Box>
                <Box height="25px" />
                <Typography variant="body1">
                  A több gyermekes anyák kedvezményére való <b>jogosultság annak a hónapnak az első
                    napján kezdődik, amelyben Ön először – akár csak egy napig is – több gyermeket
                    nevelő anyának minősül.</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  A több gyermekes anyák kedvezményre való <b>jogosultság annak a hónapnak az utolsó
                    napján szűnik meg, amelyben Ön utoljára, legalább egy napig több gyermeket
                    nevelő anyának minősül.</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Például egy házaspár 2026-ban három gyermeket nevel, akik 6, 9 és 12 évesek. Az anya
                  adóelőleg-nyilatkozatot ad januárban a három gyermeket nevelő anyák kedvezményéről
                  és a családi kedvezményről. A szülők novemberben elválnak, és a két idősebb gyermek
                  az édesapával marad. Ebben az esetben az anya utoljára novemberben tekinthető három
                  gyermeket nevelő anyának. Ezért vissza kell vonnia a három gyermeket nevelő anyák
                  kedvezményére tett nyilatkozatát, amit a „Több gyermeket nevelő anyák kedvezménye”
                  elnevezésű nyilatkozat beadásával tehet meg. Módosítania kell továbbá a családi
                  kedvezményre vonatkozó nyilatkozatát is, amit a „Családi kedvezmény nyilatkozat”
                  elnevezésű nyomtatványon tehet meg.
                </Typography>
                <Box height="25px" />
                <Typography variant="h6">
                  <b>Mennyi kedvezmény jár?</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>Több gyermeket nevelő anyák kedvezménye</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>A több gyermekes anyák kedvezményének nincs összegkorlátja, minden a
                    jogosultsági hónapban megszerzett, a kedvezmény alapját képező jövedelemre
                    érvényesíthető.</b>
                </Typography>
                <Typography variant="body1">
                  <b>Ha az anyának van olyan összevont adóalapba tartozó jövedelme, ami nem képezi
                    a több gyermeket nevelő anyák kedvezményének az alapját, akkor arra családi
                    kedvezményt is érvényesíthet.</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Például, ha az anya a jogszabályban meghatározott összegnél magasabb összegű
                  végkielégítést kap, akkor arra a többgyermekes anyák kedvezménye nem
                  érvényesíthető, azonban a családi kedvezmény igen.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Adóalap hiányában a fel nem használt családi kedvezmény 15 százaléka családi
                  járulékkedvezmény jogcímén vehető igénybe a társadalombiztosítási járulék terhére.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>Családi kedvezmény</b>
                </Typography>
                <Typography variant="body1">
                  A családi kedvezmény összege 2026-ban az egy évvel korábbi összeg duplájára emelkedik.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>2026. január 1-től a családi kedvezmény összege</b> az eltartottak számától függően
                  <b> kedvezményezett eltartottanként havonta,</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1" component={ListItems}>
                  <li>ha egy eltartott van a családban, <b>133 340 forint,</b></li>
                  <li>ha két eltartott van a családban, <b>266 660 forint,</b></li>
                  <li>ha három vagy annál több eltartott van a családban, <b>440 000 forint.</b></li>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Ez a gyakorlatban azt jelenti, hogy a családi kedvezmény igénybevételével
                  <b> kedvezményezett eltartottanként havonta,</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1" component={ListItems}>
                  <li>ha egy eltartott van a családban, <b>20 ezer forinttal,</b></li>
                  <li>ha két eltartott van a családban, <b>40 ezer forinttal,</b></li>
                  <li>ha három vagy több eltartott van a családban, <b>66 ezer forinttal</b></li>
                </Typography>
                <Typography variant="body1">
                  magasabb összegű <b>nettó</b> kereset áll a családok rendelkezésére.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>Kedvezményezett eltartott:</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1" component={ListItems}>
                  <li>aki után a magánszemély a Cst. szerint családi pótlékra jogosult,</li>
                  <li>aki a családi pótlékra saját jogán jogosult,</li>
                  <li>a rokkantsági járadékban részesülő személy,</li>
                  <li>a magzat a fogantatás 91. napjától megszületéséig, az erről szóló orvosi igazolás
                    alapján,</li>
                  <li>a bíróság döntése, egyezség, a családi pótlék folyósítójánál tett közös nyilatkozat
                    alapján felváltva gondozott gyermek mindkét szülőnél, valamint a szülők
                    házastársainál is.</li>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Ha a magánszemély azért érvényesíthet családi kedvezményt, mert valamely EGT-állam
                  vagy Magyarországgal határos, nem EGT-állam (Ukrajna, Szerbia) jogszabálya alapján
                  családi pótlékra, rokkantsági járadékra vagy más hasonló ellátásra jogosult,
                  kedvezményezett eltartottként azt a gyermeket veheti figyelembe, aki után
                  Magyarországon a Cst. megfelelő alkalmazásával a családi pótlékra való jogosultsága
                  megállapítható lenne.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>Eltartott:</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1" component={ListItems}>
                  <li>a kedvezményezett eltartott,</li>
                  <li>az, aki a családi pótlék összegének megállapítása szempontjából figyelembe
                    vehető vagy figyelembe vehető lenne, akkor is,</li>
                </Typography>
                <Box marginLeft="24px">
                  <Typography variant="body1" component={ListItems}>
                    <li>ha a kedvezményezett eltartott után nem családi pótlékot, hanem
                      rokkantsági járadékot folyósítanak,</li>
                    <li>ha a kedvezményezett eltartott után családi pótlékot nem állapítanak meg,
                      például magzat esetében,</li>
                    <li>vagy a családi pótlék összegét a gyermekek száma nem befolyásolja,
                      például tartósan beteg gyermek után járó emelt összegű családi pótlék.</li>
                  </Typography>
                </Box>
                <Box height="25px" />
                <Typography variant="body1">
                  Példa: Egy családban négyen élnek: apa, anya, a nappali tagozatos egyetemista fiuk és
                  az apa húga, aki rokkantsági járadékot kap. A rokkantsági járadékban részesülő személy
                  után a testvére, az apa veszi igénybe a családi kedvezményt.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Miután az egyetemista is eltartottnak számít, a családban az eltartottak száma két fő.
                  Emiatt a rokkantsági járadékban részesülő személy után havi 266 660 forint családi
                  kedvezményt érvényesíthet az apa.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>2026. január 1-től emelkedik a tartósan beteg, illetve súlyosan fogyatékos
                    kedvezményezett eltartott után érvényesíthető emelt összegű családi kedvezmény is.</b>
                </Typography>
                <Typography variant="body1">
                  <b>A tartósan beteg, illetve súlyosan fogyatékos</b> kedvezményezett eltartott után a családi
                  kedvezmény havi összege <b>133 340 forinttal emelt összegben vehető igénybe.</b> (2.)
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Tartósan beteg, illetve <b>súlyosan fogyatékos személy</b>(3.) az, aki:
                </Typography>
                <Box height="25px" />
                <Typography variant="body1" component={ListItems}>
                  <li>tizennyolc évesnél fiatalabb, és a külön jogszabályban (4.) meghatározott betegsége,
                    illetve fogyatékossága miatt állandó vagy fokozott felügyeletre, gondozásra
                    szorul,</li>
                  <li>tizennyolc évesnél idősebb, és a tizennyolcadik életévének betöltése előtt
                    munkaképességét legalább 67 százalékban elvesztette, legalább 50 százalékos
                    mértékű egészségkárosodást szenvedett, vagy akinek egészségi állapota a
                    rehabilitációs hatóság minősítése alapján a tizennyolcadik életévének betöltése
                    előtt sem haladja meg az 50 százalékos mértéket, és ez az állapot legalább egy
                    éve tart, vagy előreláthatólag legalább egy évig fennáll,</li>
                  <li>a 18. életévét betöltötte, és a <b>magasabb összegű családi pótlék helyett
                    fogyatékossági támogatásban</b> részesül. (5.)</li>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Példa: Egy anya három kiskorú gyermeket nevel, akik közül az egyik súlyosan
                  fogyatékos.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  A családi kedvezmény havi összege:
                </Typography>
                <Typography variant="body1" component={ListItems}>
                  <li>három kedvezményezett eltartott után 3*440 000 = 1 320 000 forint,</li>
                  <li>a fogyatékos gyermek után további 133 340 forint,</li>
                </Typography>
                <Typography variant="body1">
                  azaz összesen 1 453 340 forint.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>Családi járulékkedvezmény</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  A magánszemély az őt megillető családi kedvezményt a biztosítottként (6.) fizetendő
                  társadalombiztosítási járulék csökkentésére is felhasználhatja, ha a kedvezmény teljes
                  összegét az szja-alapból, adóelőleg-alapból nem lehetett teljes összegben érvényesíteni.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  A családi járulékkedvezmény összege a családi kedvezmény adóalappal, adóelőleg-
                  alappal szemben nem érvényesített részének a 15 százaléka, de legfeljebb a tb-járulék
                  összege.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  A családi járulékkedvezményt a munkáltató, kifizető automatikusan figyelembe veszi,
                  ha a magánszemély a családi kedvezmény érvényesítéséről szóló adóelőleg-
                  nyilatkozatban nem jelöli be azt, hogy nem kéri a járulékkedvezmény figyelembevételét.
                  Ha a magánszemély az adóelőleg-nyilatkozatban kéri, hogy a munkáltató, kifizető ne
                  érvényesítsen járulékkedvezményt, akkor a munkáltató, kifizető a családi kedvezményre
                  jogosító keretből csak azt az összeget számolja el, ami az szja-előlegből érvényesíthető.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Példa: Egy egyedülálló 38 éves édesanya 2 kiskorú gyermeke után kéri a családi
                  kedvezményt, a havi keresete 500 000 ezer forint.
                  Az anya jogosult a két gyermeket nevelő anyák kedvezményére, amit a munkabérére
                  igénybe tud venni.
                </Typography>
                <Typography variant="body1">
                  A családi kedvezmény havi összege 2*266 660=533 320 forint, aminek a 15 százalékát
                  adóalap hiányában családi járulékkedvezmény jogcímén tud igénybe venni.
                </Typography>
                <Typography variant="body1">
                  Adóalapként nem érvényesíthető kedvezmény 15 százaléka: 79 998 forint.
                  Az anya fizetését terhelő társadalombiztosítási járulék összege: 500 000*18,5%=
                  92 500.
                </Typography>
                <Typography variant="body1">
                  Az anya a családi kedvezményt teljes összegben, családi járulékkedvezményként
                  érvényesíteni tudja.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>Adatváltozáskor mit kell tenni?</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Ha a gyermeket nevelő anya jogosultsága a négy vagy több gyermeket nevelő anyák
                  kedvezményére, a három gyermeket nevelő anyák kedvezményére, a két gyermeket
                  nevelő anyák kedvezményére vagy a 30 év alatti anyák kedvezményére úgy áll fenn az
                  év egészében, hogy annak jogcíme megváltozik, a kedvezményt az év egészére az év
                  első napján érvényesíthető kedvezmény – ha ilyenből több is van, az anya döntése
                  szerinti – jogcím alapján lehet igénybe venni. Ilyen esetben új adóelőleg-nyilatkozat
                  megtételére és a kedvezmény alapjául szolgáló jövedelmek jogcímek közötti
                  megosztására nincs szükség.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Ha a többgyermeket nevelő anyák kedvezményére való jogosultság jogcíme év közben
                  a fentiek szerint megváltozik, akkor az anyának a következő évben, a változásnak
                  megfelelően kell új adóelőleg nyilatkozatot adnia a munkáltatója, kifizetője részére.
                  Például, ha az anya 2026 szeptemberében megszüli a negyedik gyermekét, akkor 2027-
                  ben új adóelőleg nyilatkozatot kell adnia az új kedvezményről.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Ha a nyilatkozatban közölt egyéb adatok változnak, <b>Ön köteles haladéktalanul új
                    nyilatkozatot tenni!</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>A módosítás nem ezen a nyilatkozaton kell beadnia!</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1" component={ListItems}>
                  <li><b>Ha a családi kedvezményre vonatkozó adatokat kívánja módosítani,</b> akkor a
                    „Családi kedvezmény nyilatkozat” elnevezésű nyomtatványt töltse ki és adja be.
                    Ebben az I. Blokk jobb felső sarkában lévő, <b>Módosított nyilatkozat</b> feliratú
                    kódkockában kell X-szel jelölnie. <b>Nem kell új nyilatkozatot tenni a gyermek megszületésekor,</b> ha az adóévben
                    a magánszemély a <b>családi kedvezményt már a magzat után is érvényesítette.</b></li>
                  <li><b>Ha Ön a több gyermekes anyák kedvezményére vonatkozó nyilatkozatát
                    kívánja módosítani,</b> visszavonni, akkor a „Több gyermeket nevelő anyák
                    kedvezménye” elnevezésű adóelőleg-nyilatkozatot töltse ki és adja be, amelyben
                    az I. Blokk jobb felső sarkában <b>(a „Módosított nyilatkozat” kódkockában)</b> kell
                    X-szel jelölnie.</li>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Ha Ön év közben új munkáltatónál helyezkedik el, és új nyilatkozatot tesz, az <b>nem
                    számít módosított nyilatkozatnak.</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  A családi kedvezményről és családi járulékkedvezményről, valamint a több gyerekes
                  anyák kedvezményéről bővebb tájékoztatást olvashat a NAV honlapján
                  (www.nav.gov.hu) az „Szja adóalap-kedvezmények” című 73. számú információs
                  füzetben.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>Külföldi magánszemély milyen feltételek mellett érvényesítheti a kedvezményt?</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Ha Ön a Cst. szabályai alapján nem jogosult családi pótlékra, azonban valamely EGT-
                  állam vagy Magyarországgal határos nem EGT-állam (Ukrajna, Szerbia) jogszabálya alapján
                  a családi pótlékra, rokkantsági járadékra vagy más hasonló ellátásra jogosult, és
                  az alábbiakban részletezett feltételek egyidejűleg teljesülnek, akkor Ön is érvényesítheti
                  a családi kedvezményt. Ez esetben kedvezményezett eltartottként azt a magánszemélyt
                  (gyermeket) veheti figyelembe, aki után Magyarországon a Cst. megfelelő
                  alkalmazásával a családi pótlékra való jogosultsága megállapítható lenne; eltartottként
                  pedig azt a magánszemélyt (gyermeket), akit a Cst. megfelelő alkalmazásával más
                  magánszemély (gyermek) után járó családi pótlék megállapításánál figyelembe lehetne
                  venni.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  A több gyermekes anyák kedvezményét a külföldi anya akkor veheti igénybe, ha a
                  családi pótlékra való jogosultsága a gyermekek után a Cst. szerint fennáll, vagy 12 évig
                  fennállt.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  A kedvezmény érvényesítésének további feltétele, hogy Ön azonos vagy hasonló
                  <b> kedvezményt</b> ugyanarra az időszakra <b>másik államban</b> (ahol önálló és nem önálló
                  tevékenységéből, nyugdíjból és más, hasonló, a korábbi foglalkoztatásból származó
                  jövedelme megadóztatható) - figyelemmel a kettős adóztatás elkerüléséről szóló
                  nemzetközi egyezmények rendelkezéseire is - <b>nem vett és nem is vesz igénybe.</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  A külföldi adóügyi illetőségű magánszemély a kedvezményt Magyarországon csak
                  akkor érvényesítheti, ha az adóévben megszerzett összes jövedelmének – ideértve a
                  Magyarországon nem adóztatható jövedelmet is – <b>75 százaléka Magyarországon
                    adózik.</b> Az adóévben megszerzett összes jövedelembe beleszámít az önálló és nem
                  önálló tevékenységből származó jövedelem – ideértve különösen a vállalkozói
                  jövedelmet és a vállalkozói osztalékalapot vagy az átalányadó alapját –, valamint a
                  nyugdíj és más hasonló, a korábbi foglalkoztatásból megszerzett jövedelem, függetlenül
                  attól, hogy mely országban adókötelesek.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>Ha Ön külföldi adóügyi illetőségű, a „Kiegészítő nyilatkozat a külföldi adóügyi
                    illetőségű magánszemélyek adóalap-kedvezményének érvényesítéséhez”
                    nyilatkozatot is ki kell töltenie és a munkáltató, kifizető részére átadnia a
                    kedvezményének igénybevételéhez. Adóazonosító jelet ebben az esetben is meg kell
                    adnia.</b>
                </Typography>
              </BgBox>
              <Box marginLeft="16px">
                <SmallBgBox>
                  <Typography variant="body1">
                    (1.) A Cst. alapján.
                  </Typography>
                </SmallBgBox>
                <WithoutSeparator height="25px" />
                <SmallBgBox>
                  <Typography variant="body1">
                    (2.) Az Szja törvény 29/A. § (2a) bekezdése alapján.
                  </Typography>
                </SmallBgBox>
                <WithoutSeparator height="25px" />
                <SmallBgBox>
                  <Typography variant="body1">
                    (3.) A családok támogatásáról szóló 1998. évi LXXXIV. tv. (a továbbiakban: Cst.) 4. § f) pontja alapján.
                  </Typography>
                </SmallBgBox>
                <WithoutSeparator height="25px" />
                <SmallBgBox>
                  <Typography variant="body1">
                    (4.) A magasabb összegű családi pótlékra jogosító betegségekről és fogyatékosságokról szóló 5/2003. (II. 19.)
                    ESzCsM rendelet alapján.
                  </Typography>
                </SmallBgBox>
                <WithoutSeparator height="25px" />
                <SmallBgBox>
                  <Typography variant="body1">
                    (5.) Szja törvény 29/A. § (2a) bekezdése.
                  </Typography>
                </SmallBgBox>
                <WithoutSeparator height="25px" />
                <SmallBgBox>
                  <Typography variant="body1">
                    (6.) A társadalombiztosítás ellátásaira jogosultakról, valamint ezen ellátások fedezetéről szóló 2019. évi CXXII.
                    törvény 6. §-a szerint biztosított.
                  </Typography>
                </SmallBgBox>
              </Box>
            </InlineFlexBoxs>
            <Box height="16px" />
            <BgBox>
              <Box height="25px" />
              <Typography variant="h5" component={Titles}>
                <b>Az adóelőleg-nyilatkozat kitöltése</b>
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                Az első részben tüntesse fel a nevét és adóazonosító jelét.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                <b>A második</b> részben kell nyilatkozni az adóalap kedvezményekről.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                <b>Az 1. pontban</b> kell nyilatkozni, hogy Ön jogosultként családi kedvezményt kíván
                érvényesíteni. Jelölje, hogy a két gyermeket nevelő anyák kedvezményét, vagy a három
                gyermeket nevelő anyák kedvezményét, vagy a négy vagy több gyermeket nevelő anyák
                kedvezményét kívánja igénybe venni. Itt nyilatkozik arról is, hogy azonos vagy hasonló
                kedvezményt ugyanarra az időszakra másik államban – ahol önálló és nem önálló
                tevékenységéből, nyugdíjból és más, hasonló, a korábbi foglalkoztatásból származó
                jövedelme megadóztatható (figyelemmel a kettős adóztatás elkerüléséről szóló
                nemzetközi egyezmények rendelkezéseire is) nem vett és nem is vesz igénybe.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                A <b>harmadik</b> részben kell megadni a gyermekek, eltartottak, kedvezményezett
                eltartottak adatait.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                <b>A 2. pontban</b> kell megadnia a családi kedvezmény és a többgyermekes anyák
                kedvezménye érvényesítéséhez szükséges gyermekek, eltartottak adatait.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                Írja be a gyermekek, eltartottak nevét, adóazonosító jelét. Ha a kedvezményezett
                eltartott magzat, akkor „<b>magzat</b>”-ot tüntessen fel, az adóazonosítót nem kell kitölteni.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                Ha a gyermek, eltartott után családi kedvezményt kíván igénybe venni, akkor töltse ki a
                „EM” (Eltartotti minőség) és a „JJ” (Jogosultság jogcíme) kódkockát.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                <b>Eltartotti minőség kódjai:</b>
              </Typography>
              <Typography variant="body1" component={ListItems}>
                <li>„1” kód - Kedvezményezett eltartott</li>
                <li>„2” kód - Eltartott</li>
                <li>„3” kód - Felváltva gondozott gyermek</li>
                <li>
                  „4” kód - Tartósan beteg, illetve súlyosan fogyatékos
                  személy (gyermek)
                </li>
                <li>
                  „5” kód - Felváltva gondozott tartósan beteg, illetve
                  súlyosan fogyatékos személy (gyermek)
                </li>
                <li>„0” kód - Családi kedvezménynél figyelembe nem vehető személy (ezt tüntesse
                  fel, ha a gyermeket a családi kedvezménynél nem lehet figyelembe venni, de a
                  több gyermeket nevelő anyák kedvezményénél igen).</li>
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                Az eltartottak neve mellett az <b>eltartotti minőséget</b> – azaz, hogy miként kell őt a családi
                kedvezmény számításánál figyelembe venni – külön kódkockában kell jelölni.
                Magzatnál név helyett a „magzat” kifejezést tüntesse fel, és az „1” kódot
                (kedvezményezett eltartott) jelölje! A magzat(ok) a várandósság orvosi igazolása
                alapján a fogantatástól számított 91. nap hónapjától az élve születés napját megelőző
                hónapig vehetők figyelembe. Az orvosi igazolást a nyilatkozathoz nem kell csatolni, de
                elévülési időig, azaz a bevallás benyújtásának évét követő 5. év végéig meg kell őrizni.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                A „4” és „5” kód szerinti tartósan beteg, illetve súlyosan fogyatékos személyen a Cst.-
                ben meghatározott tartósan beteg, illetve súlyosan fogyatékos személyt kell érteni.
                Tartósan beteg, illetve súlyosan fogyatékos személy az a 18. életévét betöltött
                magánszemély is, aki a magasabb összegű családi pótlék helyett fogyatékossági
                támogatásban részesül.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                A családi kedvezmény érvényesítéséhez az összes eltartott nevét, adóazonosító jelét meg
                kell adni, kivéve a magzatét, <b>adóazonosító jel nélkül a nyilatkozat érvénytelen.</b>
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                Az eltartottak mellett meg kell jelölni, hogy adott eltartott után a nyilatkozatot adó
                magánszemély milyen jogcímen jogosult a családi kedvezmény érvényesítésére.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                Ha az eltartotti minőség kódja „0”, akkor a jogosultság jogcímét nem kell kitölteni.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                <b>Jogosultság jogcímei:</b>
              </Typography>
              <Typography variant="body1" component={ListItems}>
                <li>„a” kód – Gyermek után családi pótlékra jogosult, vagy ilyen jogosulttal közös
                  háztartásban élő házastárs</li>
                <li>„b” kód – Várandós nő</li>
                <li>„c” kód – Családi pótlékra saját jogán jogosult, vagy ilyen jogosulttal közös
                  háztartásban élő hozzátartozó (ideértve a gyermek szüleinek hozzátartozóit is)</li>
                <li>„d” kód – Rokkantsági járadékban részesülő, vagy ilyen jogosulttal közös
                  háztartásban élő hozzátartozó (ideértve a gyermek szüleinek hozzátartozóit is)
                </li>
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                Ha az eltartotti minőség kódja „0”, akkor a jogosultság jogcímét nem kell kitölteni.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                Ha a gyermeket a több gyermekes anyák kedvezményénél kívánja figyelembe venni,
                akkor töltse ki a „TA” (Több gyermeket nevelő anyák kedvezménye) kódot.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                Több gyermeket nevelő anyák kedvezménye kódok:
              </Typography>
              <Typography variant="body1" component={ListItems}>
                <li>V. Vérszerinti gyerek</li>
                <li>O. Örökbefogadott gyerek</li>
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                <b>Ezt a kódkockát csak akkor töltse ki, ha a gyermek, eltartott a több gyermeket
                  nevelő anyák kedvezményére jogosítja Önt, ellenkező esetben hagyja üresen.
                  Miután magzatot nem lehet figyelembe venni a több gyermekes anyák
                  kedvezményénél, ezért, ha a jogosultság jogcíme „b”, akkor ezt a kódkockát nem
                  töltheti ki.</b>
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                Ha Ön
              </Typography>
              <Typography variant="body1" component={ListItems}>
                <li>a két gyermeket nevelő anyák kedvezményére jogosult, akkor 2 gyermek,</li>
                <li>a három gyermeket nevelő anyák kedvezményére jogosult, akkor 3 gyermek,</li>
                <li>a négy vagy több gyermeket nevelő anyák kedvezményére jogosult, akkor
                  legalább 4 gyermek</li>
              </Typography>
              <Typography variant="body1">
                adatait tüntesse fel.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                Ha a gyermeknek nincs adóazonosító jele és családi kedvezményt nem érvényesít utána,
                akkor adja meg a gyermek születési helyét, idejét.
              </Typography>
              <Typography variant="body1">
                Megadhatja az anya a gyermek születési helyét és idejét akkor is, ha a gyermek már
                felnőtt, de megromlott a kapcsolatuk így nem tudja az anya az adóazonosító jelet.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                <b>A negyedik részben</b> kell nyilatkozni a családi kedvezmény érvényesítéséről.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                <b>A 3. pontban</b> kérjük, jelölje az arra szolgáló négyzetben X-szel, hogy a családi
                kedvezményt egyedül, vagy jogosultnak minősülő házastársával, élettársával közösen
                kívánja érvényesíteni!
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                <b>A 4. ponthoz:</b> Ön e pontban kérheti munkáltatóját, hogy az alább megjelölt családi
                kedvezményt kizárólag az adóelőleg-alapjára tekintettel érvényesítse, a
                társadalombiztosítási járulékból ne. Ha e nyilatkozatot megteszi, a munkáltató nem
                fogja érvényesíteni a járulékkedvezményt még akkor sem, ha az 5. pontban megjelölt
                családi kedvezmény teljes összegű igénybevételére az Ön adóelőleg-alapja nem nyújt
                fedezetet.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                <b>Az 5. pontban</b> nyilatkozik arról, hogy milyen módon kéri a családi kedvezmény
                érvényesítését. Az érvényesíteni kívánt családi kedvezményt meghatározhatja mind az
                összeg [a) sor], mind a kedvezményezett eltartottak számának [b) sor] megjelölésével.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                Ha a kedvezményezett eltartottak között van tartósan beteg, illetve súlyosan fogyatékos
                személy (eltartotti minősítése „4”, vagy „5”), akkor a kedvezményt csak az összeg
                megjelölésével lehet felosztani a jogosultak között.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                Ha a megjelölt összeg vagy a feltüntetett kedvezményezett eltartottak száma alapján járó
                összeg magasabb, mint az Ön jövedelme, például munkabére, akkor a különbözetet a
                kifizető járulékkedvezményként veszi figyelembe feltéve, ha Ön biztosított és nem tett
                nyilatkozatot a 4. pontban.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                Ha a nyilatkozat a) sorában a kedvezményezett eltartottak száma alapján kiszámítható
                családi kedvezmény maximális összegénél kisebb összeget, vagy b) sorában a
                kedvezményezett eltartottak számánál kisebb számot jelöl meg, a fennmaradó
                kedvezményt jogosultnak minősülő házastársa, élettársa ugyancsak a munkáltatójának,
                kifizetőjének adott nyilatkozattal érvényesítheti.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                <b>Az ötödik részben</b> a sorokat az Ön házastársa vagy élettársa adataival kell kitölteni, ha
                közös nyilatkozatot kell tenniük. Ha a házastársának, élettársának van adóelőleget
                megállapító munkáltatója, rendszeres bevételt juttató kifizetője, akkor itt kell feltüntetni
                annak megnevezését, adószámát.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                Nem kell közös nyilatkozatot tenni azzal a volt házastárssal, élettárssal, aki a felváltva
                gondozott gyermekük után érvényesíti az 50-50 százalékos családi kedvezményt.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                <b>A hatodik részt</b> az Ön munkáltatójának (kifizetőjének) kell kitöltenie.
              </Typography>
            </BgBox>
            <Box height="16px" />
          </Box>
          <Box height="6px" />
        </Box>
        <OcFooter />
      </Box>
    </ThemeProvider>
  );
};

export default MyTaxCombinedTaxCreditInformationPage;
